import { Status, ShipmentType } from '@views/Shipments/types';

// Version
export const VERSION = '/version';
export const BACKEND_VERSION = '/version/backend';

// Logos
export const FLOX_LOGO_BLUE_SRC = '/images/flox-logo-blue.svg';
export const FLOX_ICON_BLUE_SRC = '/images/flox-icon-blue.svg';
export const FLOX_LOGO_STANDARD_REVERSE_SRC =
  '/images/flox-logo-standard-reverse.svg';

// External registration URL (configurable for local dev)
export const FLOX_REGISTRATION_URL =
  import.meta.env.VITE_FLOX_REGISTRATION_URL || 'https://app.flox.is/register';

// Login / Registration
export const LOGIN_WITH_CREDENTIALS_URL = '/Auth/LoginWithCredentials';
export const REGISTRATION_URL = '/Auth/Register';
export const FORGOTTEN_PASSWORD_URL = '/Auth/SendForgottenPasswordLink';
export const RESET_PASSWORD_URL = '/Auth/SetNewPasswordWithToken';
export const REFRESH_TOKEN_URL = '/Auth/RefreshToken';
export const CONFIRM_EMAIL_URL = '/Auth/ConfirmEmail';
export const INVITE_TEAM_MEMBER_URL = '/Auth/InviteTeamMember';
export const JOIN_URL = '/Auth/Join';
export const LIST_USERS_URL = '/Auth/ListUsers';
export const DEACTIVATE_TEAM_MEMBER_URL = '/Auth/DeactivateTeamMember';
export const ACTIVATE_TEAM_MEMBER_URL = '/Auth/ActivateTeamMember';
export const GET_TWO_FACTOR_SECRET_URL = '/Auth/GetTwoFactorSecret';
export const ENABLE_TWO_FACTOR_AUTH_URL = '/Auth/EnableTwoFactorAuth';
export const LOGIN_WITH_TWO_FACTOR_AUTH_URL = '/Auth/LoginWithTwoFactorAuth';
// Holly 3.0 Registration spec
export const RESEND_CONFIRMATION_URL = '/Auth/ResendConfirmation';
/**
 * localStorage flag set on successful login/register to recognise this
 * browser as a "known" one on later /register hits. Replaces the prior
 * server-set `flox_known_user` HttpOnly cookie.
 */
export const FLOX_KNOWN_BROWSER_KEY = 'floxKnown';
/**
 * localStorage key holding the FusionAuth two-factor trust id issued when the
 * user ticks "Remember this browser" on the 2FA form. Sent with credentials
 * logins to skip the 2FA challenge; deliberately survives logout.
 */
export const TWO_FACTOR_TRUST_ID_KEY = 'twoFactorTrustId';

// Inventory
export const CREATE_SKU_URL = '/Inventory/Create';
export const CREATE_PRODUCT_WITH_SKUS_URL = '/Inventory/CreateProductWithSkus';
export const UPDATE_SKU_URL = '/Inventory/Update';
export const GET_SKU_URL = '/Inventory/Get';
export const UPDATE_PRODUCT_DETAILS_URL = '/Inventory/UpdateProductDetails';
export const ADJUST_STOCK_BY_FILE = '/Inventory/ImportStockLevels';
export const LIST_PRODUCTS_URL = '/Inventory/List/Products';
export const LIST_SKUS_URL = '/Inventory/List/Skus';
export const ARCHIVE_SKU_URL = '/Inventory/Archive';
export const GET_PRODUCT_DETAILS_SUGGESTIONS =
  '/Inventory/GetProductDetailsSuggestions';
export const INVENTORY_IMAGES_URL =
  import.meta.env.MODE === 'production'
    ? 'https://static.flox.is'
    : 'http://localhost:8080/download/storage/v1/b/flox-static/o';
export const LIST_METADATA_FIELDS_URL = '/Inventory/ListMetaDataFields';
export const GET_SKU_TOTAL_STOCK_METRICS = '/Inventory/GetSkuTotalStockMetrics';
// Integrations
export const INTEGRATIONS_GET_URL = '/Integrations/GetIntegrations';
export const ADD_INTEGRATION_URL = '/Integrations/AddIntegration';
export const REMOVE_INTEGRATION_URL = '/Integrations/RemoveIntegration';
export const CREATE_OAUTH_CONSENT_LINK_URL =
  '/Integrations/CreateOAuthConsentLink';
export const CONNECT_OAUTH_ACCOUNT_URL = '/Integrations/ConnectOAuthAccount';
// Warehouses
export const AVAILABLE_WAREHOUSES_URL = '/Match/List/Contracted';
export const LSP_WAREHOUSES_URL = '/Warehouse/List';
export const WAREHOUSE_SEARCH_URL = '/Warehouse/Search';
export const WAREHOUSE_CREATE = '/Warehouse/Create';
export const WAREHOUSE_UPDATE = '/Warehouse/Update';
export const WAREHOUSE_GET = '/Warehouse/Get';
export const WAREHOUSE_SEARCH_GET = '/Warehouse/Search';
export const WAREHOUSE_DELIST = '/Warehouse/Delist';
export const HERE_APIKEY = 'f0tGXxtAhk_uegH03IpLQK73fvVHaX3g8No3TaEjVmM';
export const MAPBOX_APIKEY =
  'pk.eyJ1IjoibWFsY21jYyIsImEiOiJjbThnMmJkc2gwazBnMnFzNXo1NDZ6dG9uIn0.7IQj6PJSqRCFJDjHwsdQqg';
export const WAREHOUSE_IMAGES_URL =
  import.meta.env.MODE === 'production'
    ? 'https://static.flox.is'
    : 'http://localhost:8080/download/storage/v1/b/flox-static/o';
export const GET_SKU_STOCK = '/Inventory/ExportSkus';

// Depots
export const DEPOT_LIST = '/Depot/List/Depots';
export const DEPOT_CREATE = '/Depot/Create';
export const DEPOT_UPDATE = '/Depot/Update';
export const DEPOT_GET = '/Depot/Get';
export const DEPOT_IMAGES_URL =
  import.meta.env.MODE === 'production'
    ? 'https://static.flox.is'
    : 'http://localhost:8080/download/storage/v1/b/flox-static/o';

// Fleet
export const FLEET_GET = '/Vehicle/List/Vehicles';
export const VEHICLE_CREATE = '/Vehicle/Create';
export const VEHICLE_UPDATE = '/Vehicle/Update';
export const VEHICLE_GET = '/Vehicle/Get';
export const VEHICLE_CATEGORIES = '/Vehicle/Categories';
export const FLEET_IMAGES_URL =
  import.meta.env.MODE === 'production'
    ? 'https://static.flox.is'
    : 'http://localhost:8080/download/storage/v1/b/flox-static/o';
export const UPLOAD_FLEET_MASTER_URL = '/Vehicle/BulkCreate';
export const FLEET_AVAILABILITY = '/VehicleAvailability/List';
export const FLEET_AVAILABILITY_CREATE = '/VehicleAvailability/Create';
export const FLEET_AVAILABILITY_UPDATE = '/VehicleAvailability/Update';

// Ratecards
export const RATECARDS_GET = '/Pricing/List/Ratecards';
export const RATECARD_GET = '/Pricing/Get/Ratecard';
export const DAILY_RATECARD_CREATE = '/Pricing/Create/DailyRatecard';
export const POSTCODE_RATECARD_CREATE = '/Pricing/Import/PostcodeRatecard';
export const ADDITIONAL_FTL_RATECARD_CREATE =
  '/Pricing/Create/AdditionalLoadRatecard';
export const MILEAGE_RATECARD_CREATE = '/Pricing/Create/MileageRatecard';
export const MILEAGE_RATECARD_UPDATE = '/Pricing/Update/MileageRatecard';
export const MILEAGE_RATECARD_IMPORT = '/Pricing/Import/MileageRatecard';
export const NETWORK_RATECARD_CREATE = '/Pricing/Create/NetworkRatecard';
export const NETWORK_RATECARDS_LIST = '/Pricing/List/NetworkRatecards';
export const NETWORK_NAMES_LIST = '/Pricing/List/NetworkNames';
export const NETWORK_RATECARD_UPDATE = '/Pricing/Update/NetworkRatecard';
export const NETWORK_RATECARD_GET = '/Pricing/Get/NetworkRatecard';
export const NETWORK_RATECARD_QUOTE = '/Pricing/Quote/NetworkRatecard';
export const NETWORK_RATECARD_SUSPEND = '/Pricing/Suspend/NetworkRatecard';
export const NETWORK_RATECARD_ARCHIVE = '/Pricing/Archive/NetworkRatecard';

// Transport Orders
export const TRANSPORT_ORDER_CREATE = '/TransportOrder/Create';
export const TRANSPORT_ORDER_PREPARE =
  '/TransportOrder/PrepareFromDespatchNote';
export const TRANSPORT_ORDER_QUOTES = '/TransportOrder/GetQuotes';

// Customer Master
export const CUSTOMER_GET = '/Customer/List';
export const CUSTOMER_CREATE = '/Customer/Create';
export const CUSTOMER_UPDATE = '/Customer/Update';
export const CUSTOMER_ARCHIVE = '/Customer/Archive';
export const CUSTOMER_BULK_CREATE = '/Customer/BulkCreate';

// Supplier Master
export const SUPPLIER_GET = '/Supplier/List';
export const SUPPLIER_CREATE = '/Supplier/Create';
export const SUPPLIER_UPDATE = '/Supplier/Update';
export const SUPPLIER_BULK_CREATE = '/Supplier/BulkCreate';

// Master Data Imports (AI review)
export const MASTER_DATA_IMPORT_CREATE = '/MasterDataImport/Create';
export const MASTER_DATA_IMPORT_LIST = '/MasterDataImport/List';
export const MASTER_DATA_IMPORT_GET = '/MasterDataImport/Get';
export const MASTER_DATA_IMPORT_APPROVE = '/MasterDataImport/Approve';
export const MASTER_DATA_IMPORT_DISCARD = '/MasterDataImport/Discard';

// Clients
export const MATCH_CLIENTS_URL = '/Match/Clients';

// Profile
export const BUSINESS_PROFILE_GET = '/BusinessProfile/Get';
export const BUSINESS_PROFILE_CREATE = '/BusinessProfile/Create';
export const BUSINESS_PROFILE_UPDATE = '/BusinessProfile/Update';
export const BUSINESS_PROFILE_AGREE_WAREHOUSE_TANDCS =
  '/BusinessProfile/AgreeToWarehouseTandCs';
export const STARTER_CHECKLIST_GET = '/BusinessProfile/GetStarterChecklist';
export const GET_SUPPORTED_BANKS = '/BusinessProfile/GetSupportedBanks';
export const GET_BANK_DETAILS = '/BusinessProfile/GetBankDetails';
export const UPDATE_BANK_DETAILS = '/BusinessProfile/UpdateBankDetails';
export const AUTHORISE_BANK_ACCOUNT = '/BusinessProfile/AuthoriseBankAccount';
export const UPDATE_BANK_ACCOUNT_CONSENT =
  '/BusinessProfile/UpdateBankAccountConsent';
export const REVOKE_BANK_ACCOUNT_CONSENT =
  '/BusinessProfile/RevokeBankAccountConsent';
export const AUTHORISE_PAYMENT = '/Finance/AuthorisePayment';

// Finance
export const MAKE_PAYMENT = '/Finance/MakePayment';

// Matching
export const MATCH_LIST = '/Match/List';
export const CONTRACTED_MATCH_LIST = '/Match/List/Contracted';
export const ADD_WAREHOUSE_MATCH = `/Match/AddWarehouseMatch`;
export const MATCH_REQUEST_LSP_CONNECTION = '/Match/RequestLspConnection';
export const DELETE_WAREHOUSE_MATCH = `/Match/DeleteWarehouseMatch`;
export const PROPOSE_WAREHOUSE_MATCH_DETAILS = `/Match/ProposeWarehouseMatchDetails`;
export const ACCEPT_WAREHOUSE_MATCH = `/Match/AcceptWarehouseMatch`;
export const GET_WAREHOUSE_MATCH_PRICING_SCHEDULE =
  '/Match/GetWarehouseMatchPricingSchedule';

// SKUs
export const UPLOAD_SKU_MASTER_URL = '/Inventory/BulkCreate';

// Shipment notes
export const CREATE_INBOUND_SHIPMENT_NOTE_URL =
  '/SupplyChainProcess/CreateInboundShipmentNote';
export const CREATE_OUTBOUND_SHIPMENT_NOTE_URL =
  '/SupplyChainProcess/CreateOutboundShipmentNote';

export const INBOUND_SHIPMENT_TYPE = 'Inbound';
export const OUTBOUND_SHIPMENT_TYPE = 'Outbound';

// Supply chain process
export const LIST_SUPPLY_CHAIN_PROCESSES_URL = '/SupplyChainProcess/List';
export const APPROVED_INBOUND_SHIPMENT_NOTE_URL =
  '/SupplyChainProcess/ApproveInboundShipmentNote';
export const FINALISE_GOODS_RECEIVED_NOTE_URL =
  '/SupplyChainProcess/FinaliseGoodsReceivedNote';
export const CREATE_DESPATCH_NOTE = '/SupplyChainProcess/CreateDespatchNote';
export const PREVIEW_PRODUCT_ALLOCATION =
  '/SupplyChainProcess/PreviewProductAllocation';
export const AUTHORISE_FOR_PICKING =
  '/SupplyChainProcess/AuthoriseDespatchNote';
export const CONFIRM_PICKING_NOTE = '/SupplyChainProcess/ConfirmPickingNote';
export const CREATE_PROOF_OF_DELIVERY =
  '/SupplyChainProcess/ApproveOutboundShipmentNote';
export const SUGGESTED_ID_URL =
  '/SupplyChainProcess/GetSupplyChainProcessIdSuggestion';
export const ARCHIVE_SUPPLY_CHAIN_PROCESS = '/SupplyChainProcess/Archive';

// Sales orders (Shopify orders awaiting warehouse assignment)
export const FULFILLABLE_WAREHOUSES_URL = '/SalesOrder/FulfillableWarehouses';
export const CONVERT_SALES_ORDER_URL = '/SalesOrder/Convert';
export const IGNORE_SALES_ORDER_URL = '/SalesOrder/Ignore';

// Search
export const MACRO_SEARCH_URL = '/Search/Macro';

// Misc settings
export const DEBOUNCE_TIME_IN_MS = 500;

// User roles
export const WAREHOUSE_CLIENT = 'WarehouseClient';
export const WAREHOUSE_MANAGER = 'WarehouseManager';
export const WAREHOUSE_OPERATOR = 'WarehouseOperator';

// Notifications
export const GET_NOTIFICATIONS = '/Notification/List';
export const GET_NOVU_CONFIG = '/Notification/Config';
export const GET_NOTIFICATION_PREFERENCES = '/UserProfile/GetNotificationPreferences';
export const UPDATE_NOTIFICATION_PREFERENCES = '/UserProfile/UpdateNotificationPreferences';
export const NOVU_BACKEND_URL = `${window.location.origin}/notifications`;
export const NOVU_SOCKET_URL = window.location.origin;

// Invoicing
export const INVOICE_LIST = '/Finance/ListBillingCycles';
export const APPROVE_INVOICE = '/Finance/ApproveInvoice';
export const INVOICE_PDF = '/Finance/InvoicePdf';

// Currencies
export const SUPPORTED_CURRENCY_GROUPS = [
  {
    groupName: 'Popular currencies',
    currencies: [
      {
        symbol: '£',
        name: 'British Pound Sterling',
        symbol_native: '£',
        decimal_digits: 2,
        rounding: 0,
        code: 'GBP',
        name_plural: 'British pounds sterling',
      },
      {
        symbol: '€',
        name: 'Euro',
        symbol_native: '€',
        decimal_digits: 2,
        rounding: 0,
        code: 'EUR',
        name_plural: 'euros',
      },
      {
        symbol: '$',
        name: 'US Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'USD',
        name_plural: 'US dollars',
      },
    ],
  },
  {
    groupName: 'More currencies',
    currencies: [
      {
        symbol: 'CA$',
        name: 'Canadian Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'CAD',
        name_plural: 'Canadian dollars',
      },
      {
        symbol: 'AED',
        name: 'United Arab Emirates Dirham',
        symbol_native: 'د.إ.‏',
        decimal_digits: 2,
        rounding: 0,
        code: 'AED',
        name_plural: 'UAE dirhams',
      },
      {
        symbol: 'Af',
        name: 'Afghan Afghani',
        symbol_native: '؋',
        decimal_digits: 0,
        rounding: 0,
        code: 'AFN',
        name_plural: 'Afghan Afghanis',
      },
      {
        symbol: 'ALL',
        name: 'Albanian Lek',
        symbol_native: 'Lek',
        decimal_digits: 0,
        rounding: 0,
        code: 'ALL',
        name_plural: 'Albanian lekë',
      },
      {
        symbol: 'AMD',
        name: 'Armenian Dram',
        symbol_native: 'դր.',
        decimal_digits: 0,
        rounding: 0,
        code: 'AMD',
        name_plural: 'Armenian drams',
      },
      {
        symbol: 'AR$',
        name: 'Argentine Peso',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'ARS',
        name_plural: 'Argentine pesos',
      },
      {
        symbol: 'AU$',
        name: 'Australian Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'AUD',
        name_plural: 'Australian dollars',
      },
      {
        symbol: 'man.',
        name: 'Azerbaijani Manat',
        symbol_native: 'ман.',
        decimal_digits: 2,
        rounding: 0,
        code: 'AZN',
        name_plural: 'Azerbaijani manats',
      },
      {
        symbol: 'KM',
        name: 'Bosnia-Herzegovina Convertible Mark',
        symbol_native: 'KM',
        decimal_digits: 2,
        rounding: 0,
        code: 'BAM',
        name_plural: 'Bosnia-Herzegovina convertible marks',
      },
      {
        symbol: 'Tk',
        name: 'Bangladeshi Taka',
        symbol_native: '৳',
        decimal_digits: 2,
        rounding: 0,
        code: 'BDT',
        name_plural: 'Bangladeshi takas',
      },
      {
        symbol: 'BGN',
        name: 'Bulgarian Lev',
        symbol_native: 'лв.',
        decimal_digits: 2,
        rounding: 0,
        code: 'BGN',
        name_plural: 'Bulgarian leva',
      },
      {
        symbol: 'BD',
        name: 'Bahraini Dinar',
        symbol_native: 'د.ب.‏',
        decimal_digits: 3,
        rounding: 0,
        code: 'BHD',
        name_plural: 'Bahraini dinars',
      },
      {
        symbol: 'FBu',
        name: 'Burundian Franc',
        symbol_native: 'FBu',
        decimal_digits: 0,
        rounding: 0,
        code: 'BIF',
        name_plural: 'Burundian francs',
      },
      {
        symbol: 'BN$',
        name: 'Brunei Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'BND',
        name_plural: 'Brunei dollars',
      },
      {
        symbol: 'Bs',
        name: 'Bolivian Boliviano',
        symbol_native: 'Bs',
        decimal_digits: 2,
        rounding: 0,
        code: 'BOB',
        name_plural: 'Bolivian bolivianos',
      },
      {
        symbol: 'R$',
        name: 'Brazilian Real',
        symbol_native: 'R$',
        decimal_digits: 2,
        rounding: 0,
        code: 'BRL',
        name_plural: 'Brazilian reals',
      },
      {
        symbol: 'BWP',
        name: 'Botswanan Pula',
        symbol_native: 'P',
        decimal_digits: 2,
        rounding: 0,
        code: 'BWP',
        name_plural: 'Botswanan pulas',
      },
      {
        symbol: 'BYR',
        name: 'Belarusian Ruble',
        symbol_native: 'BYR',
        decimal_digits: 0,
        rounding: 0,
        code: 'BYR',
        name_plural: 'Belarusian rubles',
      },
      {
        symbol: 'BZ$',
        name: 'Belize Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'BZD',
        name_plural: 'Belize dollars',
      },
      {
        symbol: 'CDF',
        name: 'Congolese Franc',
        symbol_native: 'FrCD',
        decimal_digits: 2,
        rounding: 0,
        code: 'CDF',
        name_plural: 'Congolese francs',
      },
      {
        symbol: 'CHF',
        name: 'Swiss Franc',
        symbol_native: 'CHF',
        decimal_digits: 2,
        rounding: 0.05,
        code: 'CHF',
        name_plural: 'Swiss francs',
      },
      {
        symbol: 'CL$',
        name: 'Chilean Peso',
        symbol_native: '$',
        decimal_digits: 0,
        rounding: 0,
        code: 'CLP',
        name_plural: 'Chilean pesos',
      },
      {
        symbol: 'CN¥',
        name: 'Chinese Yuan',
        symbol_native: 'CN¥',
        decimal_digits: 2,
        rounding: 0,
        code: 'CNY',
        name_plural: 'Chinese yuan',
      },
      {
        symbol: 'CO$',
        name: 'Colombian Peso',
        symbol_native: '$',
        decimal_digits: 0,
        rounding: 0,
        code: 'COP',
        name_plural: 'Colombian pesos',
      },
      {
        symbol: '₡',
        name: 'Costa Rican Colón',
        symbol_native: '₡',
        decimal_digits: 0,
        rounding: 0,
        code: 'CRC',
        name_plural: 'Costa Rican colóns',
      },
      {
        symbol: 'CV$',
        name: 'Cape Verdean Escudo',
        symbol_native: 'CV$',
        decimal_digits: 2,
        rounding: 0,
        code: 'CVE',
        name_plural: 'Cape Verdean escudos',
      },
      {
        symbol: 'Kč',
        name: 'Czech Republic Koruna',
        symbol_native: 'Kč',
        decimal_digits: 2,
        rounding: 0,
        code: 'CZK',
        name_plural: 'Czech Republic korunas',
      },
      {
        symbol: 'Fdj',
        name: 'Djiboutian Franc',
        symbol_native: 'Fdj',
        decimal_digits: 0,
        rounding: 0,
        code: 'DJF',
        name_plural: 'Djiboutian francs',
      },
      {
        symbol: 'Dkr',
        name: 'Danish Krone',
        symbol_native: 'kr',
        decimal_digits: 2,
        rounding: 0,
        code: 'DKK',
        name_plural: 'Danish kroner',
      },
      {
        symbol: 'RD$',
        name: 'Dominican Peso',
        symbol_native: 'RD$',
        decimal_digits: 2,
        rounding: 0,
        code: 'DOP',
        name_plural: 'Dominican pesos',
      },
      {
        symbol: 'DA',
        name: 'Algerian Dinar',
        symbol_native: 'د.ج.‏',
        decimal_digits: 2,
        rounding: 0,
        code: 'DZD',
        name_plural: 'Algerian dinars',
      },
      {
        symbol: 'Ekr',
        name: 'Estonian Kroon',
        symbol_native: 'kr',
        decimal_digits: 2,
        rounding: 0,
        code: 'EEK',
        name_plural: 'Estonian kroons',
      },
      {
        symbol: 'EGP',
        name: 'Egyptian Pound',
        symbol_native: 'ج.م.‏',
        decimal_digits: 2,
        rounding: 0,
        code: 'EGP',
        name_plural: 'Egyptian pounds',
      },
      {
        symbol: 'Nfk',
        name: 'Eritrean Nakfa',
        symbol_native: 'Nfk',
        decimal_digits: 2,
        rounding: 0,
        code: 'ERN',
        name_plural: 'Eritrean nakfas',
      },
      {
        symbol: 'Br',
        name: 'Ethiopian Birr',
        symbol_native: 'Br',
        decimal_digits: 2,
        rounding: 0,
        code: 'ETB',
        name_plural: 'Ethiopian birrs',
      },
      {
        symbol: 'GEL',
        name: 'Georgian Lari',
        symbol_native: 'GEL',
        decimal_digits: 2,
        rounding: 0,
        code: 'GEL',
        name_plural: 'Georgian laris',
      },
      {
        symbol: 'GH₵',
        name: 'Ghanaian Cedi',
        symbol_native: 'GH₵',
        decimal_digits: 2,
        rounding: 0,
        code: 'GHS',
        name_plural: 'Ghanaian cedis',
      },
      {
        symbol: 'FG',
        name: 'Guinean Franc',
        symbol_native: 'FG',
        decimal_digits: 0,
        rounding: 0,
        code: 'GNF',
        name_plural: 'Guinean francs',
      },
      {
        symbol: 'GTQ',
        name: 'Guatemalan Quetzal',
        symbol_native: 'Q',
        decimal_digits: 2,
        rounding: 0,
        code: 'GTQ',
        name_plural: 'Guatemalan quetzals',
      },
      {
        symbol: 'HK$',
        name: 'Hong Kong Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'HKD',
        name_plural: 'Hong Kong dollars',
      },
      {
        symbol: 'HNL',
        name: 'Honduran Lempira',
        symbol_native: 'L',
        decimal_digits: 2,
        rounding: 0,
        code: 'HNL',
        name_plural: 'Honduran lempiras',
      },
      {
        symbol: 'kn',
        name: 'Croatian Kuna',
        symbol_native: 'kn',
        decimal_digits: 2,
        rounding: 0,
        code: 'HRK',
        name_plural: 'Croatian kunas',
      },
      {
        symbol: 'Ft',
        name: 'Hungarian Forint',
        symbol_native: 'Ft',
        decimal_digits: 0,
        rounding: 0,
        code: 'HUF',
        name_plural: 'Hungarian forints',
      },
      {
        symbol: 'Rp',
        name: 'Indonesian Rupiah',
        symbol_native: 'Rp',
        decimal_digits: 0,
        rounding: 0,
        code: 'IDR',
        name_plural: 'Indonesian rupiahs',
      },
      {
        symbol: '₪',
        name: 'Israeli New Sheqel',
        symbol_native: '₪',
        decimal_digits: 2,
        rounding: 0,
        code: 'ILS',
        name_plural: 'Israeli new sheqels',
      },
      {
        symbol: 'Rs',
        name: 'Indian Rupee',
        symbol_native: 'টকা',
        decimal_digits: 2,
        rounding: 0,
        code: 'INR',
        name_plural: 'Indian rupees',
      },
      {
        symbol: 'IQD',
        name: 'Iraqi Dinar',
        symbol_native: 'د.ع.‏',
        decimal_digits: 0,
        rounding: 0,
        code: 'IQD',
        name_plural: 'Iraqi dinars',
      },
      {
        symbol: 'IRR',
        name: 'Iranian Rial',
        symbol_native: '﷼',
        decimal_digits: 0,
        rounding: 0,
        code: 'IRR',
        name_plural: 'Iranian rials',
      },
      {
        symbol: 'Ikr',
        name: 'Icelandic Króna',
        symbol_native: 'kr',
        decimal_digits: 0,
        rounding: 0,
        code: 'ISK',
        name_plural: 'Icelandic krónur',
      },
      {
        symbol: 'J$',
        name: 'Jamaican Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'JMD',
        name_plural: 'Jamaican dollars',
      },
      {
        symbol: 'JD',
        name: 'Jordanian Dinar',
        symbol_native: 'د.أ.‏',
        decimal_digits: 3,
        rounding: 0,
        code: 'JOD',
        name_plural: 'Jordanian dinars',
      },
      {
        symbol: '¥',
        name: 'Japanese Yen',
        symbol_native: '￥',
        decimal_digits: 0,
        rounding: 0,
        code: 'JPY',
        name_plural: 'Japanese yen',
      },
      {
        symbol: 'Ksh',
        name: 'Kenyan Shilling',
        symbol_native: 'Ksh',
        decimal_digits: 2,
        rounding: 0,
        code: 'KES',
        name_plural: 'Kenyan shillings',
      },
      {
        symbol: 'KHR',
        name: 'Cambodian Riel',
        symbol_native: '៛',
        decimal_digits: 2,
        rounding: 0,
        code: 'KHR',
        name_plural: 'Cambodian riels',
      },
      {
        symbol: 'CF',
        name: 'Comorian Franc',
        symbol_native: 'FC',
        decimal_digits: 0,
        rounding: 0,
        code: 'KMF',
        name_plural: 'Comorian francs',
      },
      {
        symbol: '₩',
        name: 'South Korean Won',
        symbol_native: '₩',
        decimal_digits: 0,
        rounding: 0,
        code: 'KRW',
        name_plural: 'South Korean won',
      },
      {
        symbol: 'KD',
        name: 'Kuwaiti Dinar',
        symbol_native: 'د.ك.‏',
        decimal_digits: 3,
        rounding: 0,
        code: 'KWD',
        name_plural: 'Kuwaiti dinars',
      },
      {
        symbol: 'KZT',
        name: 'Kazakhstani Tenge',
        symbol_native: 'тңг.',
        decimal_digits: 2,
        rounding: 0,
        code: 'KZT',
        name_plural: 'Kazakhstani tenges',
      },
      {
        symbol: 'LB£',
        name: 'Lebanese Pound',
        symbol_native: 'ل.ل.‏',
        decimal_digits: 0,
        rounding: 0,
        code: 'LBP',
        name_plural: 'Lebanese pounds',
      },
      {
        symbol: 'SLRs',
        name: 'Sri Lankan Rupee',
        symbol_native: 'SL Re',
        decimal_digits: 2,
        rounding: 0,
        code: 'LKR',
        name_plural: 'Sri Lankan rupees',
      },
      {
        symbol: 'Lt',
        name: 'Lithuanian Litas',
        symbol_native: 'Lt',
        decimal_digits: 2,
        rounding: 0,
        code: 'LTL',
        name_plural: 'Lithuanian litai',
      },
      {
        symbol: 'Ls',
        name: 'Latvian Lats',
        symbol_native: 'Ls',
        decimal_digits: 2,
        rounding: 0,
        code: 'LVL',
        name_plural: 'Latvian lati',
      },
      {
        symbol: 'LD',
        name: 'Libyan Dinar',
        symbol_native: 'د.ل.‏',
        decimal_digits: 3,
        rounding: 0,
        code: 'LYD',
        name_plural: 'Libyan dinars',
      },
      {
        symbol: 'MAD',
        name: 'Moroccan Dirham',
        symbol_native: 'د.م.‏',
        decimal_digits: 2,
        rounding: 0,
        code: 'MAD',
        name_plural: 'Moroccan dirhams',
      },
      {
        symbol: 'MDL',
        name: 'Moldovan Leu',
        symbol_native: 'MDL',
        decimal_digits: 2,
        rounding: 0,
        code: 'MDL',
        name_plural: 'Moldovan lei',
      },
      {
        symbol: 'MGA',
        name: 'Malagasy Ariary',
        symbol_native: 'MGA',
        decimal_digits: 0,
        rounding: 0,
        code: 'MGA',
        name_plural: 'Malagasy Ariaries',
      },
      {
        symbol: 'MKD',
        name: 'Macedonian Denar',
        symbol_native: 'MKD',
        decimal_digits: 2,
        rounding: 0,
        code: 'MKD',
        name_plural: 'Macedonian denari',
      },
      {
        symbol: 'MMK',
        name: 'Myanma Kyat',
        symbol_native: 'K',
        decimal_digits: 0,
        rounding: 0,
        code: 'MMK',
        name_plural: 'Myanma kyats',
      },
      {
        symbol: 'MOP$',
        name: 'Macanese Pataca',
        symbol_native: 'MOP$',
        decimal_digits: 2,
        rounding: 0,
        code: 'MOP',
        name_plural: 'Macanese patacas',
      },
      {
        symbol: 'MURs',
        name: 'Mauritian Rupee',
        symbol_native: 'MURs',
        decimal_digits: 0,
        rounding: 0,
        code: 'MUR',
        name_plural: 'Mauritian rupees',
      },
      {
        symbol: 'MX$',
        name: 'Mexican Peso',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'MXN',
        name_plural: 'Mexican pesos',
      },
      {
        symbol: 'RM',
        name: 'Malaysian Ringgit',
        symbol_native: 'RM',
        decimal_digits: 2,
        rounding: 0,
        code: 'MYR',
        name_plural: 'Malaysian ringgits',
      },
      {
        symbol: 'MTn',
        name: 'Mozambican Metical',
        symbol_native: 'MTn',
        decimal_digits: 2,
        rounding: 0,
        code: 'MZN',
        name_plural: 'Mozambican meticals',
      },
      {
        symbol: 'N$',
        name: 'Namibian Dollar',
        symbol_native: 'N$',
        decimal_digits: 2,
        rounding: 0,
        code: 'NAD',
        name_plural: 'Namibian dollars',
      },
      {
        symbol: '₦',
        name: 'Nigerian Naira',
        symbol_native: '₦',
        decimal_digits: 2,
        rounding: 0,
        code: 'NGN',
        name_plural: 'Nigerian nairas',
      },
      {
        symbol: 'C$',
        name: 'Nicaraguan Córdoba',
        symbol_native: 'C$',
        decimal_digits: 2,
        rounding: 0,
        code: 'NIO',
        name_plural: 'Nicaraguan córdobas',
      },
      {
        symbol: 'Nkr',
        name: 'Norwegian Krone',
        symbol_native: 'kr',
        decimal_digits: 2,
        rounding: 0,
        code: 'NOK',
        name_plural: 'Norwegian kroner',
      },
      {
        symbol: 'NPRs',
        name: 'Nepalese Rupee',
        symbol_native: 'नेरू',
        decimal_digits: 2,
        rounding: 0,
        code: 'NPR',
        name_plural: 'Nepalese rupees',
      },
      {
        symbol: 'NZ$',
        name: 'New Zealand Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'NZD',
        name_plural: 'New Zealand dollars',
      },
      {
        symbol: 'OMR',
        name: 'Omani Rial',
        symbol_native: 'ر.ع.‏',
        decimal_digits: 3,
        rounding: 0,
        code: 'OMR',
        name_plural: 'Omani rials',
      },
      {
        symbol: 'B/.',
        name: 'Panamanian Balboa',
        symbol_native: 'B/.',
        decimal_digits: 2,
        rounding: 0,
        code: 'PAB',
        name_plural: 'Panamanian balboas',
      },
      {
        symbol: 'S/.',
        name: 'Peruvian Nuevo Sol',
        symbol_native: 'S/.',
        decimal_digits: 2,
        rounding: 0,
        code: 'PEN',
        name_plural: 'Peruvian nuevos soles',
      },
      {
        symbol: '₱',
        name: 'Philippine Peso',
        symbol_native: '₱',
        decimal_digits: 2,
        rounding: 0,
        code: 'PHP',
        name_plural: 'Philippine pesos',
      },
      {
        symbol: 'PKRs',
        name: 'Pakistani Rupee',
        symbol_native: '₨',
        decimal_digits: 0,
        rounding: 0,
        code: 'PKR',
        name_plural: 'Pakistani rupees',
      },
      {
        symbol: 'zł',
        name: 'Polish Zloty',
        symbol_native: 'zł',
        decimal_digits: 2,
        rounding: 0,
        code: 'PLN',
        name_plural: 'Polish zlotys',
      },
      {
        symbol: '₲',
        name: 'Paraguayan Guarani',
        symbol_native: '₲',
        decimal_digits: 0,
        rounding: 0,
        code: 'PYG',
        name_plural: 'Paraguayan guaranis',
      },
      {
        symbol: 'QR',
        name: 'Qatari Rial',
        symbol_native: 'ر.ق.‏',
        decimal_digits: 2,
        rounding: 0,
        code: 'QAR',
        name_plural: 'Qatari rials',
      },
      {
        symbol: 'RON',
        name: 'Romanian Leu',
        symbol_native: 'RON',
        decimal_digits: 2,
        rounding: 0,
        code: 'RON',
        name_plural: 'Romanian lei',
      },
      {
        symbol: 'din.',
        name: 'Serbian Dinar',
        symbol_native: 'дин.',
        decimal_digits: 0,
        rounding: 0,
        code: 'RSD',
        name_plural: 'Serbian dinars',
      },
      {
        symbol: 'RUB',
        name: 'Russian Ruble',
        symbol_native: 'руб.',
        decimal_digits: 2,
        rounding: 0,
        code: 'RUB',
        name_plural: 'Russian rubles',
      },
      {
        symbol: 'RWF',
        name: 'Rwandan Franc',
        symbol_native: 'FR',
        decimal_digits: 0,
        rounding: 0,
        code: 'RWF',
        name_plural: 'Rwandan francs',
      },
      {
        symbol: 'SR',
        name: 'Saudi Riyal',
        symbol_native: 'ر.س.‏',
        decimal_digits: 2,
        rounding: 0,
        code: 'SAR',
        name_plural: 'Saudi riyals',
      },
      {
        symbol: 'SDG',
        name: 'Sudanese Pound',
        symbol_native: 'SDG',
        decimal_digits: 2,
        rounding: 0,
        code: 'SDG',
        name_plural: 'Sudanese pounds',
      },
      {
        symbol: 'Skr',
        name: 'Swedish Krona',
        symbol_native: 'kr',
        decimal_digits: 2,
        rounding: 0,
        code: 'SEK',
        name_plural: 'Swedish kronor',
      },
      {
        symbol: 'S$',
        name: 'Singapore Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'SGD',
        name_plural: 'Singapore dollars',
      },
      {
        symbol: 'Ssh',
        name: 'Somali Shilling',
        symbol_native: 'Ssh',
        decimal_digits: 0,
        rounding: 0,
        code: 'SOS',
        name_plural: 'Somali shillings',
      },
      {
        symbol: 'SY£',
        name: 'Syrian Pound',
        symbol_native: 'ل.س.‏',
        decimal_digits: 0,
        rounding: 0,
        code: 'SYP',
        name_plural: 'Syrian pounds',
      },
      {
        symbol: '฿',
        name: 'Thai Baht',
        symbol_native: '฿',
        decimal_digits: 2,
        rounding: 0,
        code: 'THB',
        name_plural: 'Thai baht',
      },
      {
        symbol: 'DT',
        name: 'Tunisian Dinar',
        symbol_native: 'د.ت.‏',
        decimal_digits: 3,
        rounding: 0,
        code: 'TND',
        name_plural: 'Tunisian dinars',
      },
      {
        symbol: 'T$',
        name: 'Tongan Paʻanga',
        symbol_native: 'T$',
        decimal_digits: 2,
        rounding: 0,
        code: 'TOP',
        name_plural: 'Tongan paʻanga',
      },
      {
        symbol: 'TL',
        name: 'Turkish Lira',
        symbol_native: 'TL',
        decimal_digits: 2,
        rounding: 0,
        code: 'TRY',
        name_plural: 'Turkish Lira',
      },
      {
        symbol: 'TT$',
        name: 'Trinidad and Tobago Dollar',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'TTD',
        name_plural: 'Trinidad and Tobago dollars',
      },
      {
        symbol: 'NT$',
        name: 'New Taiwan Dollar',
        symbol_native: 'NT$',
        decimal_digits: 2,
        rounding: 0,
        code: 'TWD',
        name_plural: 'New Taiwan dollars',
      },
      {
        symbol: 'TSh',
        name: 'Tanzanian Shilling',
        symbol_native: 'TSh',
        decimal_digits: 0,
        rounding: 0,
        code: 'TZS',
        name_plural: 'Tanzanian shillings',
      },
      {
        symbol: '₴',
        name: 'Ukrainian Hryvnia',
        symbol_native: '₴',
        decimal_digits: 2,
        rounding: 0,
        code: 'UAH',
        name_plural: 'Ukrainian hryvnias',
      },
      {
        symbol: 'USh',
        name: 'Ugandan Shilling',
        symbol_native: 'USh',
        decimal_digits: 0,
        rounding: 0,
        code: 'UGX',
        name_plural: 'Ugandan shillings',
      },
      {
        symbol: '$U',
        name: 'Uruguayan Peso',
        symbol_native: '$',
        decimal_digits: 2,
        rounding: 0,
        code: 'UYU',
        name_plural: 'Uruguayan pesos',
      },
      {
        symbol: 'UZS',
        name: 'Uzbekistan Som',
        symbol_native: 'UZS',
        decimal_digits: 0,
        rounding: 0,
        code: 'UZS',
        name_plural: 'Uzbekistan som',
      },
      {
        symbol: 'Bs.F.',
        name: 'Venezuelan Bolívar',
        symbol_native: 'Bs.F.',
        decimal_digits: 2,
        rounding: 0,
        code: 'VEF',
        name_plural: 'Venezuelan bolívars',
      },
      {
        symbol: '₫',
        name: 'Vietnamese Dong',
        symbol_native: '₫',
        decimal_digits: 0,
        rounding: 0,
        code: 'VND',
        name_plural: 'Vietnamese dong',
      },
      {
        symbol: 'FCFA',
        name: 'CFA Franc BEAC',
        symbol_native: 'FCFA',
        decimal_digits: 0,
        rounding: 0,
        code: 'XAF',
        name_plural: 'CFA francs BEAC',
      },
      {
        symbol: 'CFA',
        name: 'CFA Franc BCEAO',
        symbol_native: 'CFA',
        decimal_digits: 0,
        rounding: 0,
        code: 'XOF',
        name_plural: 'CFA francs BCEAO',
      },
      {
        symbol: 'YR',
        name: 'Yemeni Rial',
        symbol_native: 'ر.ي.‏',
        decimal_digits: 0,
        rounding: 0,
        code: 'YER',
        name_plural: 'Yemeni rials',
      },
      {
        symbol: 'R',
        name: 'South African Rand',
        symbol_native: 'R',
        decimal_digits: 2,
        rounding: 0,
        code: 'ZAR',
        name_plural: 'South African rand',
      },
      {
        symbol: 'ZK',
        name: 'Zambian Kwacha',
        symbol_native: 'ZK',
        decimal_digits: 0,
        rounding: 0,
        code: 'ZMK',
        name_plural: 'Zambian kwachas',
      },
    ],
  },
];

export const WEIGHT_UNITS = [
  {
    name: 'gram',
    label: 'g',
    value: 'g',
  },
  {
    name: 'kilogram',
    label: 'Kg',
    value: 'Kg',
  },
  {
    name: 'ounce',
    label: 'oz',
    value: 'oz',
  },
  {
    name: 'pound',
    label: 'lb',
    value: 'lb',
  },
];

export const PALLET_WEIGHT_UNITS = [
  {
    name: 'kilogram',
    label: 'Kg',
    value: 'Kg',
  },
  {
    name: 'pound',
    label: 'lb',
    value: 'lb',
  },
];

export const VOLUME_UNIT_GROUPS = [
  {
    groupName: 'Popular',
    volumeUnits: [
      {
        name: 'litre',
        label: 'l',
        value: 'l',
      },
      {
        name: 'millilitre',
        label: 'ml',
        value: 'ml',
      },
      {
        name: 'kilogram',
        label: 'Kg',
        value: 'Kg',
      },
      {
        name: 'cubic centimetre',
        label: 'cm3',
        value: 'cm3',
      },
    ],
  },
  {
    groupName: 'More volume units',
    volumeUnits: [
      {
        name: 'cubic millimetre',
        label: 'mm3',
        value: 'mm3',
      },
      {
        name: 'cubic decimetre',
        label: 'dm3',
        value: 'dm3',
      },
      {
        name: 'cubic metre',
        label: 'm3',
        value: 'm3',
      },
    ],
  },
];

export const DIMENSION_UNITS = [
  {
    name: 'millimetre',
    label: 'mm',
    value: 'mm',
  },
  {
    name: 'centimetre',
    label: 'cm',
    value: 'cm',
  },
  {
    name: 'decimetre',
    label: 'dm',
    value: 'dm',
  },
  {
    name: 'metre',
    label: 'm',
    value: 'm',
  },
];

export const QUANTITY_UNITS = [
  {
    name: 'pallet',
    label: 'Pallet',
    value: 'pallet',
  },
  {
    name: 'crate',
    label: 'Crate',
    value: 'crate',
  },
  {
    name: 'carton',
    label: 'Carton',
    value: 'carton',
  },
];

export const SKU_NAMES = [
  {
    label: 'Item',
    value: 'Item',
  },
  {
    label: 'Case',
    value: 'Case',
  },
  {
    label: 'Pallet',
    value: 'Pallet',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const COUNTRY_CODES = [
  {
    country_code: 'GB',
    country_name: 'United Kingdom',
    phone_code: 44,
  },
  {
    country_code: 'US',
    country_name: 'United States',
    phone_code: 1,
  },
  {
    country_code: 'AF',
    country_name: 'Afghanistan',
    phone_code: 93,
  },
  {
    country_code: 'AL',
    country_name: 'Albania',
    phone_code: 355,
  },
  {
    country_code: 'DZ',
    country_name: 'Algeria',
    phone_code: 213,
  },
  {
    country_code: 'AS',
    country_name: 'American Samoa',
    phone_code: 1684,
  },
  {
    country_code: 'AD',
    country_name: 'Andorra',
    phone_code: 376,
  },
  {
    country_code: 'AO',
    country_name: 'Angola',
    phone_code: 244,
  },
  {
    country_code: 'AI',
    country_name: 'Anguilla',
    phone_code: 1264,
  },
  {
    country_code: 'AG',
    country_name: 'Antigua',
    phone_code: 1268,
  },
  {
    country_code: 'AR',
    country_name: 'Argentina',
    phone_code: 54,
  },
  {
    country_code: 'AM',
    country_name: 'Armenia',
    phone_code: 374,
  },
  {
    country_code: 'AW',
    country_name: 'Aruba',
    phone_code: 297,
  },
  {
    country_code: 'AU',
    country_name: 'Australia',
    phone_code: 61,
  },
  {
    country_code: 'AT',
    country_name: 'Austria',
    phone_code: 43,
  },
  {
    country_code: 'AZ',
    country_name: 'Azerbaijan',
    phone_code: 994,
  },
  {
    country_code: 'BH',
    country_name: 'Bahrain',
    phone_code: 973,
  },
  {
    country_code: 'BD',
    country_name: 'Bangladesh',
    phone_code: 880,
  },
  {
    country_code: 'BB',
    country_name: 'Barbados',
    phone_code: 1246,
  },
  {
    country_code: 'BY',
    country_name: 'Belarus',
    phone_code: 375,
  },
  {
    country_code: 'BE',
    country_name: 'Belgium',
    phone_code: 32,
  },
  {
    country_code: 'BZ',
    country_name: 'Belize',
    phone_code: 501,
  },
  {
    country_code: 'BJ',
    country_name: 'Benin',
    phone_code: 229,
  },
  {
    country_code: 'BM',
    country_name: 'Bermuda',
    phone_code: 1441,
  },
  {
    country_code: 'BT',
    country_name: 'Bhutan',
    phone_code: 975,
  },
  {
    country_code: 'BO',
    country_name: 'Bolivia',
    phone_code: 591,
  },
  {
    country_code: 'BQ',
    country_name: 'Bonaire, Sint Eustatius and Saba',
    phone_code: 599,
  },
  {
    country_code: 'BA',
    country_name: 'Bosnia and Herzegovina',
    phone_code: 387,
  },
  {
    country_code: 'BW',
    country_name: 'Botswana',
    phone_code: 267,
  },
  {
    country_code: 'BR',
    country_name: 'Brazil',
    phone_code: 55,
  },
  {
    country_code: 'IO',
    country_name: 'British Indian Ocean Territory',
    phone_code: 246,
  },
  {
    country_code: 'VG',
    country_name: 'British Virgin Islands',
    phone_code: 1284,
  },
  {
    country_code: 'BN',
    country_name: 'Brunei',
    phone_code: 673,
  },
  {
    country_code: 'BG',
    country_name: 'Bulgaria',
    phone_code: 359,
  },
  {
    country_code: 'BF',
    country_name: 'Burkina Faso',
    phone_code: 226,
  },
  {
    country_code: 'BI',
    country_name: 'Burundi',
    phone_code: 257,
  },
  {
    country_code: 'KH',
    country_name: 'Cambodia',
    phone_code: 855,
  },
  {
    country_code: 'CM',
    country_name: 'Cameroon',
    phone_code: 237,
  },
  {
    country_code: 'CA',
    country_name: 'Canada',
    phone_code: 1,
  },
  {
    country_code: 'CV',
    country_name: 'Cape Verde',
    phone_code: 238,
  },
  {
    country_code: 'KY',
    country_name: 'Cayman Islands',
    phone_code: 1345,
  },
  {
    country_code: 'CF',
    country_name: 'Central African Republic',
    phone_code: 236,
  },
  {
    country_code: 'TD',
    country_name: 'Chad',
    phone_code: 235,
  },
  {
    country_code: 'CL',
    country_name: 'Chile',
    phone_code: 56,
  },
  {
    country_code: 'CN',
    country_name: 'China',
    phone_code: 86,
  },
  {
    country_code: 'CO',
    country_name: 'Colombia',
    phone_code: 57,
  },
  {
    country_code: 'KM',
    country_name: 'Comoros',
    phone_code: 269,
  },
  {
    country_code: 'CK',
    country_name: 'Cook Islands',
    phone_code: 682,
  },
  {
    country_code: 'CR',
    country_name: 'Costa Rica',
    phone_code: 506,
  },
  {
    country_code: 'CI',
    country_name: "Côte d'Ivoire",
    phone_code: 225,
  },
  {
    country_code: 'HR',
    country_name: 'Croatia',
    phone_code: 385,
  },
  {
    country_code: 'CU',
    country_name: 'Cuba',
    phone_code: 53,
  },
  {
    country_code: 'CW',
    country_name: 'Curaçao',
    phone_code: 599,
  },
  {
    country_code: 'CY',
    country_name: 'Cyprus',
    phone_code: 357,
  },
  {
    country_code: 'CZ',
    country_name: 'Czech Republic',
    phone_code: 420,
  },
  {
    country_code: 'CD',
    country_name: 'Democratic Republic of the Congo',
    phone_code: 243,
  },
  {
    country_code: 'DK',
    country_name: 'Denmark',
    phone_code: 45,
  },
  {
    country_code: 'DJ',
    country_name: 'Djibouti',
    phone_code: 253,
  },
  {
    country_code: 'DM',
    country_name: 'Dominica',
    phone_code: 1767,
  },
  {
    country_code: 'DO',
    country_name: 'Dominican Republic',
    phone_code: 1809,
  },
  {
    country_code: 'EC',
    country_name: 'Ecuador',
    phone_code: 593,
  },
  {
    country_code: 'EG',
    country_name: 'Egypt',
    phone_code: 20,
  },
  {
    country_code: 'SV',
    country_name: 'El Salvador',
    phone_code: 503,
  },
  {
    country_code: 'GQ',
    country_name: 'Equatorial Guinea',
    phone_code: 240,
  },
  {
    country_code: 'ER',
    country_name: 'Eritrea',
    phone_code: 291,
  },
  {
    country_code: 'EE',
    country_name: 'Estonia',
    phone_code: 372,
  },
  {
    country_code: 'ET',
    country_name: 'Ethiopia',
    phone_code: 251,
  },
  {
    country_code: 'FK',
    country_name: 'Falkland Islands',
    phone_code: 500,
  },
  {
    country_code: 'FO',
    country_name: 'Faroe Islands',
    phone_code: 298,
  },
  {
    country_code: 'FM',
    country_name: 'Federated States of Micronesia',
    phone_code: 691,
  },
  {
    country_code: 'FJ',
    country_name: 'Fiji',
    phone_code: 679,
  },
  {
    country_code: 'FI',
    country_name: 'Finland',
    phone_code: 358,
  },
  {
    country_code: 'FR',
    country_name: 'France',
    phone_code: 33,
  },
  {
    country_code: 'GF',
    country_name: 'French Guiana',
    phone_code: 594,
  },
  {
    country_code: 'PF',
    country_name: 'French Polynesia',
    phone_code: 689,
  },
  {
    country_code: 'GA',
    country_name: 'Gabon',
    phone_code: 241,
  },
  {
    country_code: 'GE',
    country_name: 'Georgia',
    phone_code: 995,
  },
  {
    country_code: 'DE',
    country_name: 'Germany',
    phone_code: 49,
  },
  {
    country_code: 'GH',
    country_name: 'Ghana',
    phone_code: 233,
  },
  {
    country_code: 'GI',
    country_name: 'Gibraltar',
    phone_code: 350,
  },
  {
    country_code: 'GR',
    country_name: 'Greece',
    phone_code: 30,
  },
  {
    country_code: 'GL',
    country_name: 'Greenland',
    phone_code: 299,
  },
  {
    country_code: 'GD',
    country_name: 'Grenada',
    phone_code: 1473,
  },
  {
    country_code: 'GP',
    country_name: 'Guadeloupe',
    phone_code: 590,
  },
  {
    country_code: 'GU',
    country_name: 'Guam',
    phone_code: 1671,
  },
  {
    country_code: 'GT',
    country_name: 'Guatemala',
    phone_code: 502,
  },
  {
    country_code: 'GG',
    country_name: 'Guernsey',
    phone_code: 44,
  },
  {
    country_code: 'GN',
    country_name: 'Guinea',
    phone_code: 224,
  },
  {
    country_code: 'GW',
    country_name: 'Guinea-Bissau',
    phone_code: 245,
  },
  {
    country_code: 'GY',
    country_name: 'Guyana',
    phone_code: 592,
  },
  {
    country_code: 'HT',
    country_name: 'Haiti',
    phone_code: 509,
  },
  {
    country_code: 'HN',
    country_name: 'Honduras',
    phone_code: 504,
  },
  {
    country_code: 'HK',
    country_name: 'Hong Kong',
    phone_code: 852,
  },
  {
    country_code: 'HU',
    country_name: 'Hungary',
    phone_code: 36,
  },
  {
    country_code: 'IS',
    country_name: 'Iceland',
    phone_code: 354,
  },
  {
    country_code: 'IN',
    country_name: 'India',
    phone_code: 91,
  },
  {
    country_code: 'ID',
    country_name: 'Indonesia',
    phone_code: 62,
  },
  {
    country_code: 'IR',
    country_name: 'Iran',
    phone_code: 98,
  },
  {
    country_code: 'IQ',
    country_name: 'Iraq',
    phone_code: 964,
  },
  {
    country_code: 'IE',
    country_name: 'Ireland',
    phone_code: 353,
  },
  {
    country_code: 'IM',
    country_name: 'Isle Of Man',
    phone_code: 44,
  },
  {
    country_code: 'IL',
    country_name: 'Israel',
    phone_code: 972,
  },
  {
    country_code: 'IT',
    country_name: 'Italy',
    phone_code: 39,
  },
  {
    country_code: 'JM',
    country_name: 'Jamaica',
    phone_code: 1876,
  },
  {
    country_code: 'JP',
    country_name: 'Japan',
    phone_code: 81,
  },
  {
    country_code: 'JE',
    country_name: 'Jersey',
    phone_code: 44,
  },
  {
    country_code: 'JO',
    country_name: 'Jordan',
    phone_code: 962,
  },
  {
    country_code: 'KZ',
    country_name: 'Kazakhstan',
    phone_code: 7,
  },
  {
    country_code: 'KE',
    country_name: 'Kenya',
    phone_code: 254,
  },
  {
    country_code: 'KI',
    country_name: 'Kiribati',
    phone_code: 686,
  },
  {
    country_code: 'XK',
    country_name: 'Kosovo',
    phone_code: 381,
  },
  {
    country_code: 'KW',
    country_name: 'Kuwait',
    phone_code: 965,
  },
  {
    country_code: 'KG',
    country_name: 'Kyrgyzstan',
    phone_code: 996,
  },
  {
    country_code: 'LA',
    country_name: 'Laos',
    phone_code: 856,
  },
  {
    country_code: 'LV',
    country_name: 'Latvia',
    phone_code: 371,
  },
  {
    country_code: 'LB',
    country_name: 'Lebanon',
    phone_code: 961,
  },
  {
    country_code: 'LS',
    country_name: 'Lesotho',
    phone_code: 266,
  },
  {
    country_code: 'LR',
    country_name: 'Liberia',
    phone_code: 231,
  },
  {
    country_code: 'LY',
    country_name: 'Libya',
    phone_code: 218,
  },
  {
    country_code: 'LI',
    country_name: 'Liechtenstein',
    phone_code: 423,
  },
  {
    country_code: 'LT',
    country_name: 'Lithuania',
    phone_code: 370,
  },
  {
    country_code: 'LU',
    country_name: 'Luxembourg',
    phone_code: 352,
  },
  {
    country_code: 'MO',
    country_name: 'Macau',
    phone_code: 853,
  },
  {
    country_code: 'MK',
    country_name: 'Macedonia',
    phone_code: 389,
  },
  {
    country_code: 'MG',
    country_name: 'Madagascar',
    phone_code: 261,
  },
  {
    country_code: 'MW',
    country_name: 'Malawi',
    phone_code: 265,
  },
  {
    country_code: 'MY',
    country_name: 'Malaysia',
    phone_code: 60,
  },
  {
    country_code: 'MV',
    country_name: 'Maldives',
    phone_code: 960,
  },
  {
    country_code: 'ML',
    country_name: 'Mali',
    phone_code: 223,
  },
  {
    country_code: 'MT',
    country_name: 'Malta',
    phone_code: 356,
  },
  {
    country_code: 'MH',
    country_name: 'Marshall Islands',
    phone_code: 692,
  },
  {
    country_code: 'MQ',
    country_name: 'Martinique',
    phone_code: 596,
  },
  {
    country_code: 'MR',
    country_name: 'Mauritania',
    phone_code: 222,
  },
  {
    country_code: 'MU',
    country_name: 'Mauritius',
    phone_code: 230,
  },
  {
    country_code: 'YT',
    country_name: 'Mayotte',
    phone_code: 262,
  },
  {
    country_code: 'MX',
    country_name: 'Mexico',
    phone_code: 52,
  },
  {
    country_code: 'MD',
    country_name: 'Moldova',
    phone_code: 373,
  },
  {
    country_code: 'MC',
    country_name: 'Monaco',
    phone_code: 377,
  },
  {
    country_code: 'MN',
    country_name: 'Mongolia',
    phone_code: 976,
  },
  {
    country_code: 'ME',
    country_name: 'Montenegro',
    phone_code: 382,
  },
  {
    country_code: 'MS',
    country_name: 'Montserrat',
    phone_code: 1664,
  },
  {
    country_code: 'MA',
    country_name: 'Morocco',
    phone_code: 212,
  },
  {
    country_code: 'MZ',
    country_name: 'Mozambique',
    phone_code: 258,
  },
  {
    country_code: 'MM',
    country_name: 'Myanmar',
    phone_code: 95,
  },
  {
    country_code: 'NA',
    country_name: 'Namibia',
    phone_code: 264,
  },
  {
    country_code: 'NR',
    country_name: 'Nauru',
    phone_code: 674,
  },
  {
    country_code: 'NP',
    country_name: 'Nepal',
    phone_code: 977,
  },
  {
    country_code: 'NL',
    country_name: 'Netherlands',
    phone_code: 31,
  },
  {
    country_code: 'NC',
    country_name: 'New Caledonia',
    phone_code: 687,
  },
  {
    country_code: 'NZ',
    country_name: 'New Zealand',
    phone_code: 64,
  },
  {
    country_code: 'NI',
    country_name: 'Nicaragua',
    phone_code: 505,
  },
  {
    country_code: 'NE',
    country_name: 'Niger',
    phone_code: 227,
  },
  {
    country_code: 'NG',
    country_name: 'Nigeria',
    phone_code: 234,
  },
  {
    country_code: 'NU',
    country_name: 'Niue',
    phone_code: 683,
  },
  {
    country_code: 'NF',
    country_name: 'Norfolk Island',
    phone_code: 672,
  },
  {
    country_code: 'KP',
    country_name: 'North Korea',
    phone_code: 850,
  },
  {
    country_code: 'MP',
    country_name: 'Northern Mariana Islands',
    phone_code: 1670,
  },
  {
    country_code: 'NO',
    country_name: 'Norway',
    phone_code: 47,
  },
  {
    country_code: 'OM',
    country_name: 'Oman',
    phone_code: 968,
  },
  {
    country_code: 'PK',
    country_name: 'Pakistan',
    phone_code: 92,
  },
  {
    country_code: 'PW',
    country_name: 'Palau',
    phone_code: 680,
  },
  {
    country_code: 'PS',
    country_name: 'Palestine',
    phone_code: 970,
  },
  {
    country_code: 'PA',
    country_name: 'Panama',
    phone_code: 507,
  },
  {
    country_code: 'PG',
    country_name: 'Papua New Guinea',
    phone_code: 675,
  },
  {
    country_code: 'PY',
    country_name: 'Paraguay',
    phone_code: 595,
  },
  {
    country_code: 'PE',
    country_name: 'Peru',
    phone_code: 51,
  },
  {
    country_code: 'PH',
    country_name: 'Philippines',
    phone_code: 63,
  },
  {
    country_code: 'PL',
    country_name: 'Poland',
    phone_code: 48,
  },
  {
    country_code: 'PT',
    country_name: 'Portugal',
    phone_code: 351,
  },
  {
    country_code: 'PR',
    country_name: 'Puerto Rico',
    phone_code: 1,
  },
  {
    country_code: 'QA',
    country_name: 'Qatar',
    phone_code: 974,
  },
  {
    country_code: 'CG',
    country_name: 'Republic of the Congo',
    phone_code: 242,
  },
  {
    country_code: 'RE',
    country_name: 'Réunion',
    phone_code: 262,
  },
  {
    country_code: 'RO',
    country_name: 'Romania',
    phone_code: 40,
  },
  {
    country_code: 'RU',
    country_name: 'Russia',
    phone_code: 7,
  },
  {
    country_code: 'RW',
    country_name: 'Rwanda',
    phone_code: 250,
  },
  {
    country_code: 'BL',
    country_name: 'Saint Barthélemy',
    phone_code: 590,
  },
  {
    country_code: 'SH',
    country_name: 'Saint Helena',
    phone_code: 290,
  },
  {
    country_code: 'KN',
    country_name: 'Saint Kitts and Nevis',
    phone_code: 1869,
  },
  {
    country_code: 'LC',
    country_name: 'Saint Lucia',
    phone_code: 1758,
  },
  {
    country_code: 'MF',
    country_name: 'Saint Martin',
    phone_code: 590,
  },
  {
    country_code: 'PM',
    country_name: 'Saint Pierre and Miquelon',
    phone_code: 508,
  },
  {
    country_code: 'VC',
    country_name: 'Saint Vincent and the Grenadines',
    phone_code: 1784,
  },
  {
    country_code: 'WS',
    country_name: 'Samoa',
    phone_code: 685,
  },
  {
    country_code: 'SM',
    country_name: 'San Marino',
    phone_code: 378,
  },
  {
    country_code: 'ST',
    country_name: 'Sao Tome and Principe',
    phone_code: 239,
  },
  {
    country_code: 'SA',
    country_name: 'Saudi Arabia',
    phone_code: 966,
  },
  {
    country_code: 'SN',
    country_name: 'Senegal',
    phone_code: 221,
  },
  {
    country_code: 'RS',
    country_name: 'Serbia',
    phone_code: 381,
  },
  {
    country_code: 'SC',
    country_name: 'Seychelles',
    phone_code: 248,
  },
  {
    country_code: 'SL',
    country_name: 'Sierra Leone',
    phone_code: 232,
  },
  {
    country_code: 'SG',
    country_name: 'Singapore',
    phone_code: 65,
  },
  {
    country_code: 'SX',
    country_name: 'Sint Maarten',
    phone_code: 599,
  },
  {
    country_code: 'SK',
    country_name: 'Slovakia',
    phone_code: 421,
  },
  {
    country_code: 'SI',
    country_name: 'Slovenia',
    phone_code: 386,
  },
  {
    country_code: 'SB',
    country_name: 'Solomon Islands',
    phone_code: 677,
  },
  {
    country_code: 'SO',
    country_name: 'Somalia',
    phone_code: 252,
  },
  {
    country_code: 'ZA',
    country_name: 'South Africa',
    phone_code: 27,
  },
  {
    country_code: 'KR',
    country_name: 'South Korea',
    phone_code: 82,
  },
  {
    country_code: 'SS',
    country_name: 'South Sudan',
    phone_code: 211,
  },
  {
    country_code: 'ES',
    country_name: 'Spain',
    phone_code: 34,
  },
  {
    country_code: 'LK',
    country_name: 'Sri Lanka',
    phone_code: 94,
  },
  {
    country_code: 'SD',
    country_name: 'Sudan',
    phone_code: 249,
  },
  {
    country_code: 'SR',
    country_name: 'Suriname',
    phone_code: 597,
  },
  {
    country_code: 'SZ',
    country_name: 'Swaziland',
    phone_code: 268,
  },
  {
    country_code: 'SE',
    country_name: 'Sweden',
    phone_code: 46,
  },
  {
    country_code: 'CH',
    country_name: 'Switzerland',
    phone_code: 41,
  },
  {
    country_code: 'SY',
    country_name: 'Syria',
    phone_code: 963,
  },
  {
    country_code: 'TW',
    country_name: 'Taiwan',
    phone_code: 886,
  },
  {
    country_code: 'TJ',
    country_name: 'Tajikistan',
    phone_code: 992,
  },
  {
    country_code: 'TZ',
    country_name: 'Tanzania',
    phone_code: 255,
  },
  {
    country_code: 'TH',
    country_name: 'Thailand',
    phone_code: 66,
  },
  {
    country_code: 'BS',
    country_name: 'The Bahamas',
    phone_code: 1242,
  },
  {
    country_code: 'GM',
    country_name: 'The Gambia',
    phone_code: 220,
  },
  {
    country_code: 'TL',
    country_name: 'Timor-Leste',
    phone_code: 670,
  },
  {
    country_code: 'TG',
    country_name: 'Togo',
    phone_code: 228,
  },
  {
    country_code: 'TK',
    country_name: 'Tokelau',
    phone_code: 690,
  },
  {
    country_code: 'TO',
    country_name: 'Tonga',
    phone_code: 676,
  },
  {
    country_code: 'TT',
    country_name: 'Trinidad and Tobago',
    phone_code: 1868,
  },
  {
    country_code: 'TN',
    country_name: 'Tunisia',
    phone_code: 216,
  },
  {
    country_code: 'TR',
    country_name: 'Turkey',
    phone_code: 90,
  },
  {
    country_code: 'TM',
    country_name: 'Turkmenistan',
    phone_code: 993,
  },
  {
    country_code: 'TC',
    country_name: 'Turks and Caicos Islands',
    phone_code: 1649,
  },
  {
    country_code: 'TV',
    country_name: 'Tuvalu',
    phone_code: 688,
  },
  {
    country_code: 'UG',
    country_name: 'Uganda',
    phone_code: 256,
  },
  {
    country_code: 'UA',
    country_name: 'Ukraine',
    phone_code: 380,
  },
  {
    country_code: 'AE',
    country_name: 'United Arab Emirates',
    phone_code: 971,
  },
  {
    country_code: 'UY',
    country_name: 'Uruguay',
    phone_code: 598,
  },
  {
    country_code: 'VI',
    country_name: 'US Virgin Islands',
    phone_code: 1340,
  },
  {
    country_code: 'UZ',
    country_name: 'Uzbekistan',
    phone_code: 998,
  },
  {
    country_code: 'VU',
    country_name: 'Vanuatu',
    phone_code: 678,
  },
  {
    country_code: 'VA',
    country_name: 'Vatican City',
    phone_code: 39,
  },
  {
    country_code: 'VE',
    country_name: 'Venezuela',
    phone_code: 58,
  },
  {
    country_code: 'VN',
    country_name: 'Vietnam',
    phone_code: 84,
  },
  {
    country_code: 'WF',
    country_name: 'Wallis and Futuna',
    phone_code: 681,
  },
  {
    country_code: 'EH',
    country_name: 'Western Sahara',
    phone_code: 212,
  },
  {
    country_code: 'YE',
    country_name: 'Yemen',
    phone_code: 967,
  },
  {
    country_code: 'ZM',
    country_name: 'Zambia',
    phone_code: 260,
  },
  {
    country_code: 'ZW',
    country_name: 'Zimbabwe',
    phone_code: 263,
  },
];

export const SHIPMENT_NOTE_STATUSES: Status[] = [
  'All',
  'Saved',
  'Created',
  'Delivered',
  'Cancelled',
];

export const SHIPMENT_NOTE_TYPES: ShipmentType[] = ['Inbound', 'Outbound'];

export const SHIPPER_QUESTION_SET = [
  {
    id: 'servicesNeeded',
    questionText: 'Please describe the services you are looking for *',
    type: 'radio',
    options: [
      'Leasable space',
      'Pallet storage',
      'e-Fulfilment',
      'Haulage and distribution',
      '3PL/4PL',
      'Value-added services',
    ],
    page: 1,
    mandatory: true,
  },
  // {
  //   id: 'storageSpaceOrMinPalletsNeeded',
  //   questionText: 'Space/pallet storage needed (in sq.m/pallets) *',
  //   type: 'text',
  //   page: 1,
  //   mandatory: false,
  // },
  {
    id: 'location',
    questionText: 'Desired Location/Region *',
    type: 'map',
    page: 1,
    mandatory: true,
  },
  {
    id: 'email',
    questionText: 'Email address *',
    type: 'text',
    page: 1,
    mandatory: true,
  },
  // {
  //   id: 'firstname',
  //   questionText: 'First name *',
  //   type: 'text',
  //   page: 1,
  //   mandatory: false,
  // },
  // {
  //   id: 'lastname',
  //   questionText: 'Last name *',
  //   type: 'text',
  //   page: 1,
  //   mandatory: false,
  // },
  // {
  //   id: 'intendedStartDate',
  //   questionText: 'Intended Start Date *',
  //   type: 'date',
  //   page: 2,
  //   mandatory: true,
  // },
  // {
  //   id: 'minimalTerm',
  //   questionText: 'Expected duration (in months) *',
  //   type: 'text',
  //   page: 2,
  //   mandatory: true,
  // },
  // {
  //   id: 'transportationNeeded',
  //   questionText: '# of inbound shipments a week *',
  //   type: 'text',
  //   page: 2,
  //   mandatory: true,
  // },
  // {
  //   id: 'averageShipmentType',
  //   questionText: 'Outbound transportation requirements *',
  //   type: 'radio',
  //   options: ['Parcels', 'Pallets', 'Other'],
  //   page: 2,
  //   mandatory: true,
  // },
  // {
  //   id: 'averageShipmentSize',
  //   questionText: '# of outbound shipments per week *',
  //   type: 'text',
  //   page: 2,
  //   mandatory: true,
  // },
  // {
  //   id: 'needed',
  //   questionText: 'Services needed *',
  //   type: 'checkbox',
  //   options: [
  //     'Leasable Space',
  //     'Managed Services',
  //     'Haulage&Distribution',
  //     'Enhanced Security',
  //     'ValueAdded Services',
  //     'Additional Accreditations',
  //   ],
  //   page: 3,
  //   mandatory: true,
  // },
  // {
  //   id: 'additionalCapabilities',
  //   questionText: 'Capabilities required',
  //   type: 'checkbox',
  //   options: [
  //     'Temperature Controlled',
  //     'Special Handling',
  //     'E-commerce and fulfilment',
  //     'Returns',
  //     'Co-packing',
  //     'IS enabled',
  //   ],
  //   page: 3,
  //   mandatory: false,
  // },
  // {
  //   id: 'typeOfBusiness',
  //   questionText: 'Please describe your business *',
  //   type: 'radio',
  //   options: ['Consumer Goods', 'Specialty or Industrial', 'Other'],
  //   page: 4,
  //   mandatory: true,
  // },
  // {
  //   id: 'sizeOfBusiness',
  //   questionText: 'Annual turnover *',
  //   type: 'radio',
  //   options: [
  //     'Micro (<£5M)',
  //     'SME (<50M)',
  //     'Large (<£500M)',
  //     'Multinational (>£500M)',
  //   ],
  //   page: 4,
  //   mandatory: true,
  // },
  // {
  //   id: 'supplyChainTeam',
  //   questionText: 'Your Logistics & Supply Chain team *',
  //   type: 'radio',
  //   options: ['1', '2-3', '4-10', '10-25', '>25'],
  //   page: 4,
  //   mandatory: true,
  // },
];

export const LSP_QUESTION_SET = [
  {
    id: 'typeOfBusiness',
    questionText: 'Please describe your business *',
    type: 'radio',
    options: [
      '3PL/4PL',
      'Warehouse / Fulfilment Service Provider',
      'Transport Service Provider',
      'Other',
    ],
    page: 1,
    mandatory: true,
  },
  // {
  //   id: 'sizeOfBusiness',
  //   questionText: 'Annual turnover *',
  //   type: 'radio',
  //   options: [
  //     'Micro (<£5M)',
  //     'SME (<50M)',
  //     'Large (<£500M)',
  //     'Multinational (>£500M)',
  //   ],
  //   page: 1,
  //   mandatory: true,
  // },
  {
    id: 'email',
    questionText: 'Email address *',
    type: 'text',
    page: 1,
    mandatory: true,
  },
  {
    id: 'firstname',
    questionText: 'First name *',
    type: 'text',
    page: 1,
    mandatory: true,
  },
  {
    id: 'lastname',
    questionText: 'Last name *',
    type: 'text',
    page: 1,
    mandatory: true,
  },
  // {
  //   id: 'maxStorageCapacityMeters',
  //   questionText: 'Max capacity, in sq.m *',
  //   type: 'text',
  //   page: 2,
  //   mandatory: true,
  // },
  // {
  //   id: 'maxStorageCapacityPallets',
  //   questionText: 'Max capacity, in pallets *',
  //   type: 'text',
  //   page: 2,
  //   mandatory: true,
  // },
  {
    id: 'availableStorageCapacityMeters',
    questionText: 'Available capacity, in sq.m *',
    type: 'text',
    page: 2,
    mandatory: true,
  },
  {
    id: 'availableStorageCapacityPallets',
    questionText: 'Available capacity, in pallets *',
    type: 'text',
    page: 2,
    mandatory: true,
  },
  {
    id: 'minServiceTermMonths',
    questionText: 'Minimum service term in months *',
    type: 'text',
    page: 2,
    mandatory: true,
  },
  {
    id: 'minServiceCapacity',
    questionText: 'Minimum service capacity, in sq.m or pallets *',
    type: 'text',
    page: 2,
    mandatory: true,
  },
  // {
  //   id: 'needed',
  //   questionText: '',
  //   type: 'checkbox',
  //   options: [
  //     'Leasable Space',
  //     'Managed Services/Fulfilment',
  //     'Haulage&Distribution',
  //     'Enhanced Security',
  //     'ValueAdded Services',
  //     'Additional Accreditations',
  //   ],
  //   page: 2,
  //   mandatory: true,
  // },
  {
    id: 'ownFleet',
    questionText: 'Transportation *',
    type: 'radio',
    options: ['Own fleet', 'Subcontracted'],
    page: 2,
    mandatory: true,
  },
  {
    id: 'temperatureControlled',
    questionText: 'Temperature controls *',
    type: 'radio',
    options: ['Ambient', 'Chilled', 'Frozen', 'Mixed'],
    page: 3,
    mandatory: true,
  },
  // {
  //   id: 'warehouse',
  //   questionText: 'Warehouse capabilites',
  //   type: 'checkbox',
  //   options: [
  //     'Racking',
  //     'High-Bay',
  //     'Hazardous',
  //     'Levelled Docks',
  //     'Picking/Labelling',
  //   ],
  //   page: 3,
  //   mandatory: true,
  // },
  // {
  //   id: 'distribution',
  //   questionText: 'Additional service capabilities',
  //   type: 'checkbox',
  //   options: [
  //     'LTL loads',
  //     'E-fulfilment',
  //     'Cross-docking',
  //     'Hazardous',
  //     'Electric vehicles',
  //   ],
  //   page: 3,
  //   mandatory: true,
  // },
  {
    id: 'targetCustomerType',
    questionText: 'Desired customer type *',
    type: 'radio',
    options: ['Consumer Goods', 'Specialty or Industrial', 'Other'],
    page: 3,
    mandatory: true,
  },
];

export const FLEET_CATEGORIES = [
  {
    label: 'Light Van',
    subtitle: 'Van < 1.5t',
    value: 'VanLessThan1AndHalft',
    weightLimitKg: 1500,
    palletLimit: 1,
  },
  {
    label: 'Light Commercial',
    subtitle: 'LDV < 3.5t',
    value: 'LgvLessThan3AndHalft',
    weightLimitKg: 3500,
    palletLimit: 6,
  },
  {
    label: 'Small Rigid',
    subtitle: '2 Axle Rigid < 7.5t',
    value: 'TwoAxleRigidLessThan7AndHalf5t',
    weightLimitKg: 7500,
    palletLimit: 10,
  },
  {
    label: 'Medium Rigid',
    subtitle: '2 Axle Rigid < 18t',
    value: 'TwoAxleRigid18t',
    weightLimitKg: 18000,
    palletLimit: 12,
  },
  {
    label: 'Large Rigid',
    subtitle: '3 Axle Rigid < 26t',
    value: 'ThreeAxleRigidLessThan26t',
    weightLimitKg: 26000,
    palletLimit: 16,
  },
  {
    label: 'Heavy Articulated',
    subtitle: 'Multi-Axle Artic > 26t',
    value: 'MultiAxleArticMoreThan26t',
    weightLimitKg: null,
    palletLimit: 26,
  },
  {
    label: 'Custom',
    subtitle: 'Special category',
    value: 'SpecialOrOther',
    weightLimitKg: null,
    palletLimit: null,
  },
];

export const WarehouseTandCsText = `(the “Service Provider”) is not a common carrier and undertakes all services subject solely to
the following Conditions which can be varied only in writing by a Director, Company Secretary or Partner of the
Service Provider.
If a Service Recipient’s acceptance document, purchase order or other documentation, received by the Service
Provider before or after notification of these Conditions, contains terms or conditions additional to, or at
variance with these Conditions, then every such additional or varying term or condition shall be of no effect.
IMPORTANT NOTE
THE SERVICE RECIPIENT’S ATTENTION IS DRAWN SPECIFICALLY TO CONDITION 3. Condition 3 has been included
herein solely to relieve the owner of the goods (including any associated packing and equipment) the subject of
this contract (the ”Goods”), or the owner’s agent, of the additional costs that the Service Provider would need to
include to recover insurance charges were its liability not limited as provided for in Condition 3.
Condition 3(e)(ii) will become operative at the option of the Service Recipient on the terms provided therein.
1) WARRANTY OF AGENCY
The Service Recipient warrants that it is either the owner of the Goods or is authorised by such owner to
accept these Conditions on the owner’s behalf.
2) SERVICE RECIPIENT’S UNDERTAKINGS
a) The Service Recipient undertakes that:

i) When presented for warehousing, the Goods shall be securely and properly packed in compliance
with any statutory regulations or official or recognised standards and in such condition as not to cause
damage or injury or the likelihood of damage or injury to the property of the Service Provider or to
any other goods, whether by spreading of damp, infestation, leakage or the escape of fumes or
substances or otherwise howsoever.
ii) Before presentation of the Goods for warehousing, the Service Recipient will inform the Service
Provider in writing of any special precautions necessitated by the nature, weight or condition of the
Goods and of any statutory duties specific to the Goods with which the Service Provider may need to
comply.
iii) It will reimburse all duties and taxes that the Service Provider may be required to pay in respect of the
Goods including situations where the liability to pay them arises due to the fault of the Service
Provider or its employees or sub-contractors.
iv) Unless prior to acceptance of the Goods by the Service Provider, the Service Provider receives written
notice containing all appropriate information, none of the Goods constitute “Waste” as defined in the
Environmental Protection Act 1990.
v) Unless prior to acceptance of the Goods by the Service Provider, the Service Provider receives written
notice containing all appropriate information, none of the Goods are or contain substances the
storage of which would require the obtaining of any consent or licence or which, if they escaped from
their packaging, would or may cause pollution of the environment or harm to human health.

vi) It will be liable for any breach of HM Customs & Excise Regulations relating to goods warehoused and
undertakes to indemnify and keep indemnified the Service Provider against all actions, proceedings,
costs, claims and demands arising out of any further breach, non-observance or non-performance of
the same.
b) Notwithstanding any notice under Condition 3(e)(ii), if there is a breach of contract by the Service
Recipient, the Service Recipient will indemnify the Service Provider against any loss or damage it suffers
which is related to the breach, and will pay all costs and expenses (including professional fees) incurred in,
and the Service Provider’s reasonable charges for, dealing with the breach and its consequences. The
Service Recipient will pay an extra storage charge equal to the amount of any fine or penalty payable by
the Service Provider wholly or partly as a result of a breach by the Service Recipient of this contract. If the
Service Provider suspects a breach of warranty in Condition 1 or of any undertaking in Condition 2(a), it
may demand the immediate removal of any goods held for the Service Recipient, or itself arrange their
removal without notice, at the Service Recipient’s expense.
3) COMPANY’S LIABILITY FOR GOODS AND OTHER LOSSES
a) Except as provided in Condition 3(c) below, the Service Provider does not insure the Goods and the
Service Recipient shall make arrangements to cover the Goods against all risks to the full insurable value
thereof (including all duties and taxes).
b) Subject only to sub-clause 3(c) below, the Service Provider excludes all liability whatsoever and howsoever
arising in respect of the Goods including (without limitation) all liability for loss, damage, duties and taxes,
deterioration, delay, non-delivery, mis-delivery, unauthorised delivery or non- compliance with
instructions (“Loss”).
c) If and to the extent that Loss is directly caused by neglect or wilful act or default of the Service Provider,
its employees (acting in furtherance of their duties as employees) or sub-contractors (acting in
furtherance of their duties as sub-contractors) and subject to sub-clause 3(f) below, the Service Provider
will accept liability for Loss up to the Limit fixed by sub-clause 3(e) below.
d) In no case whatsoever (including without limitation a case within sub-clause 3(c) above) shall the Service
Provider be liable for any loss of profit or income or indirect or consequential Loss of any kind.
e) In no case whatsoever (including inter alia a case within sub-clause 3(c) above) shall any liability of the
Service Provider (including inter alia any liability in respect of duties and taxes) exceed a limit per tonne
weight of that part of the Goods in respect of which a claim arises (“the Limit”) fixed as follows:
i)

If a higher Limit has not been implemented under (ii) below, the Limit shall be a total of £100 per
tonne.

ii) The Service Recipient may require an increase in the per tonne limit under (i) by notice in writing to be
received by the Service Provider at least 7 days before the date (“the Date”) on which the increased
Limit is required to be operative. The notice shall state the increased Limit and the nature and
maximum value of the Goods, including duty and taxes. The increased Limit shall apply in respect of
any cause of action arising after the Date. The Service Provider shall accept such increase subject to
payment by the Service Recipient within 7 days of invoice of the Service Provider’s costs in insuring
against its increased liability under the increased Limit.
f)

Without prejudice to the Service Provider’s rights under clause 6 to be paid free from deductions, any
limitation of liability on the part of the Service Provider shall be applied to any claim by the Service
Recipient before any set off or counterclaim is asserted against money due to the Service Provider.

g) The Service Provider:
i)

shall not be liable for any Claim unless it has received written notice of the Claim from the Service
Recipient within 21 days (7 days in the case of sub-contract carriage) of the cause of the Claim coming
to the Service Recipient’s knowledge or of the Goods being delivered by the Service Provider to or to
the use of the Service Recipient, whichever is the later.

ii) No legal proceedings may be brought against the Service Provider unless they are issued and served,
and no counterclaim may be raised unless full written details are received by the Service Provider,
within 9 months of the event giving rise to the Claim.
h) The Service Provider shall not be liable hereunder for any loss or damage to the extent that the same is
caused or contributed to by a breach of any of the Service Recipient’s warranties and undertakings (or by
any of the circumstances by virtue of which the Service Provider is relieved of its contractual obligations in
accordance with Condition 8).
4) EMPLOYEES AND SUB-CONTRACTORS
a) The Service Recipient and the Owner of the Goods will not take any proceedings against any employee or
sub-contractor of the Service Provider for a Claim.
b) Without prejudice to Condition 4(a), if an employee or sub-contractor pays or is liable to make a payment
to the Service Recipient or Owner of the Goods in connection with a Claim, the Service Recipient and the
Owner of the Goods will each fully indemnify the Service Provider against any claim (including all costs
and expenses) by the employee or sub-contractor against the Service Provider for reimbursement of or
indemnity against that payment to the extent that it exceeds £100 per tonne weight of that part of the
Goods the subject of a Claim or any higher figure agreed under Condition 3(e)(ii).
c) In any of the circumstances referred to in Condition 4(d) hereof, and otherwise with the written consent
of the Service Recipient, the Service Provider shall be entitled to sub-contract all or any part of its business
and in this event these Conditions shall apply to such services. The Service Provider shall be entitled to
sub-contract with others for the security, cleaning, maintenance, repair and other services and works at
the premises where the Goods are located.
d) The circumstances referred to in Condition 4(c) hereof are actual or anticipated storm, flood, fire,
explosion, breakdown or failure of plant and/or machinery, riot, civil disturbance, industrial dispute,
labour disturbance, requirement of a responsible Authority or any emergency reasonably requiring such
action by the Service Provider.
5) CHANGE OF SERVICE RECIPIENT
a) The Service Recipient may give written authority for the Goods or any part thereof to be transferred by
the Service Provider to the account of another party but subject to the Service Recipient ensuring before
the effective date of the transfer that such other party notifies the Service Provider in writing that it is to
become the Service Recipient and is to be bound by these Conditions and by any notice given under
Condition 3. Further, the Service Recipient agrees to continue to pay the Service Provider’s charges until
receipt and acceptance by the Service Provider of the other party’s written notification.
6) CHARGES, PAYMENTS AND LIEN
a) The Service Provider’s charges, which may be increased from time to time by at least 21 days’ prior notice
to the Service Recipient, shall be payable free of any deductions at such periodic intervals as may have
been agreed between the parties and in any event on the earlier of (a) the expiry of any agreed period of

credit and (b) the time immediately before the removal of the Goods from the Service Provider’s custody
or control. Interest on amounts due and unpaid shall be payable from the date when payment of such
amounts fell due and shall be calculated at the rate of 2% (per cent) for each calendar month during all or
part of which a payment is overdue. Further, the Service Provider shall have on the Goods a particular lien,
as well as a general lien entitling it to retain the Goods as security for payment of all sums claimed by the
Service Provider from the Service Recipient or the Owner of the Goods on any account (relating to the
Goods or not). Storage charges shall continue to accrue on any goods detained under lien.
7) TERMINATION
a) The Goods shall be removed by the Service Recipient from the custody or control of the Service Provider
at such date as may have been agreed between the parties. In the absence of such agreement, and
otherwise where reasonably necessary, the Service Provider may at any time by notice in writing to the
Service Recipient require the removal of the Goods within 28 days from the date of such notice or, in the
case of perishable goods, within 3 days.
b) In the event of failure by the Service Recipient by the due time to remove any of the Goods from the
custody or control of the Service Provider (notice in accordance with Condition 7(a) having been given) or
to pay any amount claimed by the Service Provider, the Service Provider may, without prejudice to its
other rights and remedies against the Service Recipient, give notice in writing to the Service Recipient of
the Service Provider’s intention to sell or otherwise dispose of the Goods at the Service Recipient’s entire
risk and expense if such amount is not paid and/or such Goods are not removed within 28 days, or in the
case of perishable goods within 3 days from the date of such notice. On the expiry of such period, if such
payment has not been made and/or the Goods have not been so removed the Service Provider shall be
entitled to sell or otherwise dispose of all or any part of the Goods at the Service Recipient’s entire risk
and expense and the proceeds of any sale or disposal shall be remitted to the Service Recipient after
deduction therefrom of all expenses and all amounts claimed by the Service Provider from the Service
Recipient or the Goods owner on any account. The Service Provider will use a reasonably appropriate
method of sale but will not be liable for any inadequacy in the price achieved.
c) In the case of perishable goods, notice under Condition 7(ii) may be combined with a notice under
Condition 7(a).
8) FRUSTRATION OF CONTRACT
a) The Service Provider shall be relieved of its contractual obligations to the extent that their performance is
prevented by, or their non-performance results wholly or partly, directly or indirectly from the act,
neglect, or default of the Service Recipient, including any breach by the Service Recipient of these
Conditions, or by storm, flood, fire, explosion, breakdown or unavailability of plant and/or machinery, riot,
civil disturbance, industrial dispute, labour disturbance or cause beyond the reasonable control of the
Service Provider.
9) GENERAL
a) Each exclusion or limitation in these Conditions exists separately and cumulatively.
b) When reasonably necessary and at the discretion of the Service Provider the Goods may be carried, stored
or handled with other compatible goods or transferred between stores.
c) Any notice or statement of account given by the Service Provider to the Service Recipient shall be duly
given if left at or sent by first class post to the last known address of the Service Recipient or by facsimile
to the last notified number or by e-mail to the last notified e-mail address and such notice or account shall

if posted be deemed to have been given 2 working days after posting and, if by facsimile or e-mail (in the
case of e-mail, with delivery reported), the next working day.
10) GOVERNING LAW
a) All contracts between the Service Provider and the Service Recipient shall be governed in all respects by
the law of England (unless the goods are stored in Scotland in which case Scottish law applies) and the
Service Recipient hereby submits to the exclusive jurisdiction of the English (or Scottish if appropriate)
courts.
11) OTHER CONDITIONS OF BUSINESS
a) If the business undertaken comprises or includes any of the following activities, then these Conditions
shall still apply to the activity except to the extent that they are inconsistent with the Service Provider’s
own standard terms (if any) for such activity in which case those standard terms shall apply (but these
Conditions will always apply in connection with the loading or unloading of the Goods, or the transfer of
the Goods as referred to in Condition 9(b)).
i)

Carriage of goods

ii) Vehicle repair and maintenance
iii) Freight Forwarding.

`;
